export default __webpack_public_path__ + "static/media/arrow-down.0775ab7e.svg";